<template>
  <div class="user_info_register">
    <div class="user_info_head">
      <div v-if="this.$route.name === 'UserInfoRegister' && userInfo.isFirst" class="deco">
        <h2>출금 정보 등록</h2>
        <p>현금 캐시백을 위한 사용자 정보와 지급 계좌 정보를 등록합니다.</p>
        <p>
          사업자의 경우 원활한 서비스 이용을 위해 개인 유형으로 신청 후 변경이 가능합니다.<br />
          사업자 회원을 원하시는 경우 정보 등록 후 [사업자 회원으로 변경] 신청을 해주세요.
        </p>
      </div>
      <div v-else class="deco">
        <h2>사업자 변경 신청</h2>
        <p>현금 캐시백을 위한 사업자의 유형을 변경 신청합니다.</p>
      </div>
    </div>
    <register-select v-if="this.$route.name === 'UserInfoChange' && !registerSelect"></register-select>
    <register-individual v-else-if="userInfo.isFirst || registerSelect === 1"></register-individual>
    <register-business v-else></register-business>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import RegisterSelect from '@/components/templates/userInfo/register/RegisterSelect';
import RegisterIndividual from '@/components/templates/userInfo/register/RegisterIndividual';
import RegisterBusiness from '@/components/templates/userInfo/register/RegisterBusiness';

export default {
  components: {
    RegisterSelect,
    RegisterIndividual,
    RegisterBusiness,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('userInfo', ['registerSelect', 'userInfo']),
  },
  methods: {
    ...mapActions('userInfo', ['setRegisterSelect', 'setModifyUserName']),
  },
  mounted() {
    this.setModifyUserName({});
  },
  beforeDestroy() {
    this.setRegisterSelect(0);
  },
};
</script>

<style></style>
